import { useLocation } from "react-router-dom";

import { UWReview } from "@covertree/new-business-uw-decision";

export function UWReviewStep() {
  const location = useLocation();

  return (
    <UWReview underwritingDecision={location?.state?.underwritingDecision} />
  );
}
